import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { H3 } from "../../brand/typographies";

const ErrorPage = () => {
  const [searchParams, _] = useSearchParams();
  const errorCode = searchParams.get("errorCode");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "20vh",
      }}
    >
      <H3 center>
        {ERROR_MESSAGES[Number(errorCode) as ErrorCodes] ??
          ERROR_MESSAGES[ErrorCodes.DEFAULT]}
      </H3>
    </Box>
  );
};

export default ErrorPage;

enum ErrorCodes {
  NO_FACILITY = 2001,
  NO_COMPANY = 2003,
  NO_SUBDOMAIN = 2004,
  MISMATCH_COMPANY_FACILITY = 4001,
  DEFAULT = 1000,
}

const ERROR_MESSAGES = {
  [ErrorCodes.NO_FACILITY]: "Facility not found. Please try again.",
  [ErrorCodes.NO_COMPANY]: "Tenant Connect is not supported at this location.",
  [ErrorCodes.NO_SUBDOMAIN]: "Subdomain not found. Try again.",
  [ErrorCodes.MISMATCH_COMPANY_FACILITY]:
    "It looks like this facility isn’t available for your company. Please try again",
  [ErrorCodes.DEFAULT]: "An unknown error occurred. Please try again.",
};
